// src/redux/slices/reservationAgentReportSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReservationAgentProduReport } from "../../Services/Service";

// ✅ THUNK (API CALL)
export const fetchAgentReport = createAsyncThunk(
    "agentReport/fetchAgentReport",
    async (params, { rejectWithValue }) => {
        try {
            const response = await ReservationAgentProduReport(params);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// ✅ SLICE
const reservationAgentReportSlice = createSlice({
    name: "agentReport",
    initialState: {
        loading: false,
        data: [],
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchAgentReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAgentReport.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAgentReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default reservationAgentReportSlice.reducer;